import React, { createContext, useContext, useState, useMemo } from 'react';
import { FormError } from '@typings/common';

interface ErrorsContextType {
  errors: FormError[];
  setErrors: React.Dispatch<React.SetStateAction<FormError[]>>;
}

const ErrorsContext = createContext<ErrorsContextType | undefined>(undefined);

export const ErrorsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [errors, setErrors] = useState<FormError[]>([]);
  const contextValue = useMemo(
    () => ({ errors, setErrors }),
    [errors, setErrors]
  );
  return (
    <ErrorsContext.Provider value={contextValue}>
      {children}
    </ErrorsContext.Provider>
  );
};

export const useErrors = (): ErrorsContextType => {
  const context = useContext(ErrorsContext);
  if (!context) {
    throw new Error('useErrors must be used within an ErrorsProvider');
  }
  return context;
};
